var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarkerBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.307,
    height: 17.089,
    viewBox: "0 0 14.307 17.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker_10_",
    "data-name": "marker (10)",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28767",
    "data-name": "Path 28767",
    d: "M9.154,0A7.162,7.162,0,0,0,2,7.154c0,3.779,6.009,8.966,6.692,9.545l.462.391.462-.391c.682-.579,6.692-5.767,6.692-9.545A7.162,7.162,0,0,0,9.154,0Zm0,10.73A3.577,3.577,0,1,1,12.73,7.154,3.577,3.577,0,0,1,9.154,10.73Z",
    fill: "#16346c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3187",
    "data-name": "Ellipse 3187",
    cx: 2.146,
    cy: 2.146,
    r: 2.146,
    transform: "translate(7.008 5.008)",
    fill: "#16346c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerBlue);
export default __webpack_public_path__ + "static/media/mapMarker_blue.ea42a60fc9b0806509fcda9765ee8a21.svg";
export { ForwardRef as ReactComponent };